import { createContext } from 'react'
import type { Session, User } from '@supabase/supabase-js'

export interface AuthContextValue {
  session: Session | null
  user: User | null
  /** true, solange die gespeicherte Session noch geprüft wird. */
  isLoading: boolean
}

// Eigene Datei, damit AuthProvider.tsx ausschliesslich Komponenten exportiert —
// sonst verliert Vite dort Fast Refresh.
export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
